/* tslint:disable */
/* eslint-disable */
/**
 * Flawtrack Backend
 * Flawtrack ASM
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * * `domain_threat` - Domain Threat
 * * `social_media` - Social Media
 * * `public_news` - Public News
 * @export
 */
export const BrandInfringementThreatTypeEnum = {
    DomainThreat: 'domain_threat',
    SocialMedia: 'social_media',
    PublicNews: 'public_news'
} as const;
export type BrandInfringementThreatTypeEnum = typeof BrandInfringementThreatTypeEnum[keyof typeof BrandInfringementThreatTypeEnum];


export function instanceOfBrandInfringementThreatTypeEnum(value: any): boolean {
    for (const key in BrandInfringementThreatTypeEnum) {
        if (Object.prototype.hasOwnProperty.call(BrandInfringementThreatTypeEnum, key)) {
            if (BrandInfringementThreatTypeEnum[key as keyof typeof BrandInfringementThreatTypeEnum] === value) {
                return true;
            }
        }
    }
    return false;
}

export function BrandInfringementThreatTypeEnumFromJSON(json: any): BrandInfringementThreatTypeEnum {
    return BrandInfringementThreatTypeEnumFromJSONTyped(json, false);
}

export function BrandInfringementThreatTypeEnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): BrandInfringementThreatTypeEnum {
    return json as BrandInfringementThreatTypeEnum;
}

export function BrandInfringementThreatTypeEnumToJSON(value?: BrandInfringementThreatTypeEnum | null): any {
    return value as any;
}

export function BrandInfringementThreatTypeEnumToJSONTyped(value: any, ignoreDiscriminator: boolean): BrandInfringementThreatTypeEnum {
    return value as BrandInfringementThreatTypeEnum;
}

